import type { Component } from "vue"
import { type Features, featureCheck } from "@/common/util/featuresUtil"

export const guardedImport = (feature: Features, loader: () => Promise<{ default: Component }>) => {
  return () => featureCheck(feature)
    ? loader()
    : import("@/modules/error/PageNotFound.vue")
}
